import React from 'react'

const initialState = {
  sortFilter: '',
  setSortFilter: Function
}

export default React.createContext(null)
